import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'

const ProtectedRoute = () => {
   const { isAuthenticated, isLoading } = useAuth()
   const location = useLocation()

   if (isLoading) {
      return <div className="flex min-h-screen items-center justify-center">Yükleniyor...</div>
   }

   if (!isAuthenticated) {
      return <Navigate to="/login" replace state={{ from: location.pathname }} />
   }

   return <Outlet />
}

export default ProtectedRoute


